// Signup Team Content Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import InputAlt from '../../form/input_alt/input_alt.jsx'
import IntlMessage from '../../common/intl/intl_message.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import Alert from '../../common/alert/alert.jsx'

class ResetContentv2 extends Component {
  static get propTypes () {
    return {
      onReset: PropTypes.func,
      onRedirectLogin: PropTypes.func,
      resetEmail: PropTypes.string
    }
  }

  static get defaultProps () {
    return {
      onReset: null,
      onRedirectLogin: null,
      resetEmail: ''
    }
  }

  constructor (props) {
    super(props)

    this.state = {
      password: ''
    }

    this.data = {
      user: null,
      invalidPasswordError: false
    }

    this.bFocus = false
    this._references = {
      alert: React.createRef(),
      inputPassword: React.createRef(),
      inputUserPassword: React.createRef()
    }
  }

  handleResize () {
    const minheight = this.getWindowHeight()
    this.setState({ contHgt: { height: minheight } })
  }

  componentDidUpdate () {
    this.setAutoFocus()
  }

  componentDidMount () {
    window.addEventListener('resize', this.handleResize.bind(this))
    this.handleResize()

    if (this._references.inputPassword.current) {
      this._references.inputPassword.current.focus()
    }
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.handleResize)
  }

  getWindowHeight () {
    const windowHgt = window.innerHeight + 'px'

    return windowHgt
  }

  setAutoFocus () {
    if (this.bFocus) {
      this.bFocus = false

      if (this._references.inputPassword.current) {
        this._references.inputPassword.current.focus()
      }
    }
  }

  render () {
    const contentClass = classnames('reset-contentv2', {})

    return (
      <div className={contentClass}>
        <div className='resetcontainerv2'>
          <div className='content'>
            <div className='header'>
              <img src='/images/common/rodeo_logo.svg' alt='logo' className='logo' />
            </div>
            {this._renderPasswordForm()}
          </div>
        </div>
        <Alert ref={this._references.alert} />
      </div>
    )
  }

  showError (msgIdent) {
    if (this._references.alert.current) {
      this._references.alert.current.onShow(
        IntlUtil.convertMessage(msgIdent),
        'error'
      )
    }
  }

  showSuccess (msgIdent) {
    if (this._references.alert.current) {
      this._references.alert.current.onShow(IntlUtil.convertMessage(msgIdent))
    }
  }

  showResetError () {
    this.showError('user.reset.msgEmailError')
    this.clearForm()
  }

  hideError () {
    this.clearForm()
  }

  showResetSuccess () {
    this.showSuccess('user.profile.msgSuccessPassword')
    this.clearForm()
  }

  clearForm () {
    this.setState({
      password: ''
    })
  }

  showLoginError () {
    this.showError('user.login.msgInvalidValues')
    this.clearForm()
  }

  hideLoginError () {
    this.clearForm()
  }

  showTeamError () {
    this.showError('user.login.msgInvalidTeams')
    this.clearForm()
  }

  /* Event Handlers */
  _onChangeInput (name, value) {
    this.setState({ [name]: value })
  }

  _onSubmitPasswordForm (ev) {
    if (ev) {
      ev.preventDefault()
    }

    let noErrors = 0

    if (
      this._references.inputPassword.current &&
      !this._references.inputPassword.current.validate()
    ) {
      this.setState(prevState =>
        ({
          ...prevState,
          invalidPasswordError: true
        })
      )

      if (!this.state.password) {
        this.showError('user.signupTeam.msgErrorPassword')
      } else {
        this.showError('user.signupTeam.msgInvalidPassword')
      }
      noErrors++
    }

    if (noErrors === 0) {
      if (this.props.onReset) {
        this.props.onReset(this.props.resetEmail, this.state.password)
      }
    }
  }

  _onBlurField (name) {
    this.setState(prevState => ({
      ...prevState,
      invalidPasswordError: false
    }))
  }

  /* Private functions */
  _renderPasswordForm () {
    const { onRedirectLogin } = this.props

    return (
      <div className='resetformv2'>
        <form
          action='#'
          method='post'
          noValidate
          onSubmit={this._onSubmitPasswordForm.bind(this)}
        >
          <div className='formheader'>
            <h2 className='title'>
              <IntlMessage ident='user.reset.resetContentTitle' />
            </h2>
            <div className='content'>
              <IntlMessage ident='user.reset.resetContentInfo' />
            </div>
          </div>

          <div className='formcontent'>
            <div className='formrow'>
              <div className='formlabel'>
                <IntlMessage ident='user.reset.passwordPlaceholder' />
              </div>
              <div className='formfield'>
                <InputAlt
                  type='password'
                  name='password'
                  className={this.state.invalidPasswordError ? 'error' : ''}
                  size={10}
                  maxLength={100}
                  label='user.reset.enterPasswordPlaceholder'
                  ref={this._references.inputPassword}
                  required
                  validations={['required', 'password']}
                  value={this.state.password}
                  onChange={this._onChangeInput.bind(this, 'password')}
                  onBlur={this._onBlurField.bind(this, 'password')}
                />
                <div className='password-requirements'>
                  <IntlMessage ident='user.reset.passwordValidLabel' />
                </div>
              </div>
            </div>

            <div className='formrowact'>
              <button
                type='submit'
                className='submit'
                onClick={this._onSubmitPasswordForm.bind(this)}
              >
                <IntlMessage ident='user.login.loginToRodeo' />
              </button>
            </div>

            <div className='formrow'>
              <a
                href='/login'
                title={IntlUtil.convertMessage(
                  'user.login.tipForgotPassword'
                )}
                className='formlink'
                onClick={onRedirectLogin}
              >
                <IntlMessage ident='user.reset.back' />
              </a>
            </div>
          </div>
        </form>
        <img
          src='/images/common/signup_info.png'
          alt='Invoice'
          className='inline-image'
        />
      </div>
    )
  }
}

export default ResetContentv2
